module.exports = __webpack_public_path__ + "img/logo.8b2e413c.png";